module.exports = __webpack_public_path__ + "img/img4.394bb621.png";